<template>
    <div class="form-container">
        <QuotationForm></QuotationForm>
    </div>
</template>

<script>
import QuotationForm from "./QuotationForm.vue";
export default {
  components: {
    QuotationForm
  },
  name: "GetQuoteComponent"
};
</script>

<style lang="scss">
@import "~@/style/_variables.scss";
* {
    box-sizing: border-box;
}
body {
    margin: 0;
    background-color: $background-gray;
    height: 100%;
}
.form-container {
    padding: 0;
    margin-top: 3.875rem;
    height: auto;
    @include breakpoint(mobile-hd-width) {
        padding: $padding-xxl;
    }
}
</style>
